function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2024 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import { login as _login, logout, getInfo as _getInfo } from '@/api/user';
import { getToken, setToken as _setToken, removeToken } from '@/utils/auth';
import router, { resetRouter } from '@/router';
import { isLoginApi } from '@/api/sms';
import Cookies from 'js-cookie';
import { Loading } from 'element-ui';
import * as roleApi from '@/api/roleApi.js';
import { formatFlatteningRoutes } from '@/utils/system.js';
import * as Auth from '@/libs/wechat';
var state = {
  token: getToken(),
  name: '',
  avatar: '',
  introduction: '',
  roles: [],
  isLogin: Cookies.get('isLogin'),
  permissions: [],
  captcha: {
    captchaVerification: '',
    secretKey: '',
    token: ''
  },
  //滑块验证token
  // 菜单数据
  menuList: JSON.parse(localStorage.getItem('MerPlatAdmin_MenuList')) || [],
  oneLvMenus: [],
  oneLvRoutes: JSON.parse(localStorage.getItem('MerPlatAdmin_oneLvRoutes')) || [],
  childMenuList: []
};
var mutations = {
  SET_TOKEN: function SET_TOKEN(state, token) {
    state.token = token;
  },
  SET_ISLOGIN: function SET_ISLOGIN(state, isLogin) {
    state.isLogin = isLogin;
    Cookies.set(isLogin);
  },
  SET_INTRODUCTION: function SET_INTRODUCTION(state, introduction) {
    state.introduction = introduction;
  },
  SET_NAME: function SET_NAME(state, name) {
    state.name = name;
  },
  SET_AVATAR: function SET_AVATAR(state, avatar) {
    state.avatar = avatar;
  },
  SET_ROLES: function SET_ROLES(state, roles) {
    state.roles = roles;
  },
  SET_PERMISSIONS: function SET_PERMISSIONS(state, permissions) {
    state.permissions = permissions;
  },
  SET_CAPTCHA: function SET_CAPTCHA(state, captcha) {
    state.captcha = captcha;
  },
  SET_MENU_LIST: function SET_MENU_LIST(state, menuList) {
    state.menuList = menuList;
  },
  setOneLvMenus: function setOneLvMenus(state, oneLvMenus) {
    state.oneLvMenus = oneLvMenus;
  },
  setOneLvRoute: function setOneLvRoute(state, oneLvRoutes) {
    state.oneLvRoutes = oneLvRoutes;
  },
  childMenuList: function childMenuList(state, list) {
    state.childMenuList = list;
  }
};
var actions = {
  // user login
  login: function login(_ref, userInfo) {
    var commit = _ref.commit;
    var account = userInfo.account,
      pwd = userInfo.pwd,
      key = userInfo.key,
      code = userInfo.code,
      wxCode = userInfo.wxCode;
    Loading.service();
    return new Promise(function (resolve, reject) {
      _login(userInfo).then(function (data) {
        var loadingInstance = Loading.service();
        loadingInstance.close();
        commit('SET_TOKEN', data.token);
        Cookies.set('JavaInfo', JSON.stringify(data));
        _setToken(data.token);
        resolve();
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // 短信是否登录
  isLogin: function isLogin(_ref2, userInfo) {
    var commit = _ref2.commit;
    return new Promise(function (resolve, reject) {
      isLoginApi().then(/*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(res) {
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                commit('SET_ISLOGIN', res.isLogin);
                resolve(res);
              case 1:
                return _context.a(2);
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref3.apply(this, arguments);
        };
      }()).catch(function (res) {
        commit('SET_ISLOGIN', false);
        reject(res);
      });
    });
  },
  // get user info
  getInfo: function getInfo(_ref4) {
    var commit = _ref4.commit,
      state = _ref4.state;
    return new Promise(function (resolve, reject) {
      _getInfo(state.token).then(function (data) {
        if (!data) {
          reject('Verification failed, please Login again.');
        }
        var roles = data.roles,
          account = data.account;
        // roles must be a non-empty array
        if (!roles || roles.length <= 0) {
          reject('getInfo: roles must be a non-null array!');
        }
        commit('SET_ROLES', roles);
        // commit('SET_ROLES', ['admin'])
        commit('SET_NAME', account);
        // commit('SET_AVATAR', avatar)
        commit('SET_AVATAR', 'http://kaifa.crmeb.net/system/images/admin_logo.png');
        commit('SET_INTRODUCTION', 'CRMEB admin');
        commit('SET_PERMISSIONS', data.permissionsList); //权限标识
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // user logout
  handleLogout: function handleLogout(_ref5) {
    var commit = _ref5.commit,
      state = _ref5.state,
      dispatch = _ref5.dispatch;
    Loading.service();
    return new Promise(function (resolve, reject) {
      logout(state.token).then(function () {
        var loadingInstance = Loading.service();
        loadingInstance.close();
        commit('SET_TOKEN', '');
        commit('SET_ROLES', []);
        commit('SET_PERMISSIONS', []);
        removeToken();
        resetRouter();
        // localStorage.clear();
        Cookies.remove('storeStaffList');
        Cookies.remove('JavaInfo');
        sessionStorage.removeItem('token');
        // reset visited views and cached views
        // to fixed https://github.com/PanJiaChen/vue-element-admin/issues/2485
        dispatch('tagsView/delAllViews', null, {
          root: true
        });
        resolve();
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // remove token
  resetToken: function resetToken(_ref6) {
    var commit = _ref6.commit;
    return new Promise(function (resolve) {
      commit('SET_TOKEN', '');
      commit('SET_ROLES', []);
      removeToken();
      resolve();
    });
  },
  // 设置token
  setToken: function setToken(_ref7, state) {
    var commit = _ref7.commit;
    return new Promise(function (resolve) {
      commit('SET_TOKEN', state.token);
      Cookies.set('JavaInfo', JSON.stringify(state));
      _setToken(data.token);
      resolve();
    });
  },
  getMenus: function getMenus(_ref8) {
    var commit = _ref8.commit;
    function formatTwoStageRoutes(arr) {
      var _this = this;
      if (arr.length <= 0) return false;
      var newArr = [];
      var cacheList = [];
      arr.forEach(function (v) {
        if (v && v.meta && v.meta.keepAlive) {
          newArr.push(_objectSpread({}, v));
          cacheList.push(v.name);
          _this.$store.dispatch('keepAliveNames/setCacheKeepAlive', cacheList);
        }
      });
      return newArr;
    }
    return new Promise(/*#__PURE__*/function () {
      var _ref9 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(resolve, reject) {
        var accessRoutes, arr, routes;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return roleApi.menuListApi();
            case 1:
              accessRoutes = _context2.v;
              accessRoutes = replaceChildListWithChildren(accessRoutes);
              //处理移动端路由
              !Auth.isPhone() ? accessRoutes = accessRoutes.filter(function (item) {
                return item.path !== '/javaMobile';
              }) : accessRoutes = accessRoutes.filter(function (item) {
                return item.path === '/javaMobile';
              });
              // let accessRoutes = formatRoutes(menusAll);
              // const accessRoutes = await dispatch('permission/generateRoutes', roles, { root: true });
              commit('SET_MENU_LIST', accessRoutes);
              localStorage.setItem('MerPlatAdmin_MenuList', JSON.stringify(accessRoutes));
              arr = formatFlatteningRoutes(router.options.routes);
              formatTwoStageRoutes(arr);
              routes = formatFlatteningRoutes(accessRoutes);
              localStorage.setItem('MerPlatAdmin_oneLvRoutes', JSON.stringify(routes));
              commit('setOneLvMenus', arr);
              commit('setOneLvRoute', routes);
              resolve(resolve);
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }));
      return function (_x2, _x3) {
        return _ref9.apply(this, arguments);
      };
    }());
  }
};

// 递归函数，用于替换 childList 为 children
function replaceChildListWithChildren(data) {
  return data.map(function (item) {
    // 检查是否存在 childList 字段
    if (item.childList) {
      // 递归处理 childList 中的每个子对象
      var children = replaceChildListWithChildren(item.childList);
      // 创建一个新的对象，将 childList 替换为 children
      var title = item.name;
      var path = item.component;
      return _objectSpread(_objectSpread({}, item), {}, {
        children: children,
        title: title,
        path: path,
        // 删除原来的 childList 字段
        childList: undefined,
        name: undefined,
        component: undefined
      });
    }
    // 如果不存在 childList 字段，直接返回原对象
    return item;
  });
}
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};